import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Col, Row } from 'reactstrap';
import { currencyToSign, formatToCurrency } from '../../../../utils/utils';
import Card from '../../../../components/Card/Card';

const PaymentOrderBadges = ({ balance }) => {
  return (
    <Row className="payments-order-badges">
      {balance.map(({ currency, balance, hold }) => (
        <Col lg="6" key={`payments-orders-badge-${currency}`}>
          <Card className="payments-order-badges-item">
            <Card.Body>
              <div className="payments-badge-title">
                <FormattedMessage id={`payments.badges.title.${currency.toLowerCase()}`} />
              </div>

              <div className="payments-badge-row">
                <span className="payments-badge-sign">
                  {currencyToSign(currency.toLowerCase())}
                </span>

                <span className="payments-badge-value">
                  <span className="payments-badge-value-title">
                    <FormattedMessage id="account.hold" defaultMessage="Hold" />
                  </span>
                  <span className="payments-badge-value-num">{formatToCurrency(hold)}</span>
                </span>

                <span className="payments-badge-value">
                  <span className="payments-badge-value-title">
                    <FormattedMessage id="account.balance" defaultMessage="Balance" />
                  </span>
                  <span className="payments-badge-value-num">{formatToCurrency(balance)}</span>
                </span>
              </div>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default PaymentOrderBadges;
